import { usePaginatedTable } from './usePaginatedTable';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { SakeDatasData } from '../types/SakeDatasData';

type CommonData = SakeDatasData;

const columnHelper = createColumnHelper<CommonData>();

const columns: ColumnDef<CommonData, any>[] = [
  columnHelper.accessor("id", {
    header: "id",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("p_name", {
    header: "都道府県",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("b_name", {
    header: "蔵名",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("brand_name", {
    header: "銘柄名",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("d_name", {
    header: "特定名称",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("polishing_ratio", {
    header: "精米歩合",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("method", {
    header: "製法",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("rice", {
    header: "米",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("yeast", {
    header: "酵母",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("abv", {
    header: "度数",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("smv", {
    header: "日本酒度",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("acidity", {
    header: "酸度",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("amino_acidity", {
    header: "アミノ酸度",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("add_water", {
    header: "加水",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("pasteurization", {
    header: "火入",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("filtration", {
    header: "ろ過",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("volume", {
    header: "容量",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor("l_name", {
    header: "購入店",
    cell: info => info.getValue(),
  }),
];

export const useSakeDatasTable = (
  url: string,
  initialPageIndex = 0,
  pageSize = 10
) => {
  return usePaginatedTable<CommonData>({
    url,
    columns,
    initialPageIndex,
    pageSize,
  });
};
